// This file is auto-generated by @hey-api/openapi-ts

import { createClientConfig } from '@/react/portainer/services/axios/configure-hey-api';

import {
  type Client,
  type ClientOptions,
  type Config,
  createClient,
  createConfig,
} from './client';
import type { ClientOptions as ClientOptions2 } from './types.gen';

/**
 * The `createClientConfig()` function will be called on client initialization
 * and the returned object will become the client's initial configuration.
 *
 * You may want to initialize your client this way instead of calling
 * `setConfig()`. This is useful for example if you're using Next.js
 * to ensure your client always has the correct values.
 */
export type CreateClientConfig<T extends ClientOptions = ClientOptions2> = (
  override?: Config<ClientOptions & T>
) => Config<Required<ClientOptions> & T>;

export const client: Client = createClient(
  createClientConfig(
    createConfig<ClientOptions2>({ baseURL: 'api', throwOnError: true })
  )
);
